import { Action } from '@ngrx/store';

import { FilterInterface, SiteFilterInterface } from '../../models';

import { SiteFilterActionType } from './site-filter-action-type.enum';

export class LoadSiteFilter implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.LoadSiteFilter;

  constructor(public readonly payload?: any) { }
}

export class LoadSiteFilterCompleted implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.LoadSiteFilterCompleted;

  constructor(public readonly payload?: SiteFilterInterface) { }
}

export class LoadSiteFilterFailed implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.LoadSiteFilterFailed;

  constructor(public readonly payload?: string) { }
}

export class LoadManagmentSiteFilter implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.LoadManagmentSiteFilter;

  constructor(public readonly payload?: any) { }
}

export class LoadManagmentSiteFilterCompleted implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.LoadManagmentSiteFilterCompleted;

  constructor(public readonly payload?: FilterInterface[]) { }
}

export class LoadManagmentSiteFilterFailed implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.LoadManagmentSiteFilterFailed;

  constructor(public readonly payload?: string) { }
}
